// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 🎨 SALLE DE RÉUNION - DESIGN MODERNE & LUMINEUX */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --bg-primary: #f8fafc;
  --bg-secondary: #ffffff;
  --bg-card: #ffffff;
  --bg-elevated: #f1f5f9;
  --border-color: #e2e8f0;
  --border-hover: #cbd5e1;
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --text-muted: #94a3b8;
  --accent-primary: #2563eb;
  --accent-secondary: #7c3aed;
  --accent-light: #dbeafe;
  --accent-glow: rgba(37, 99, 235, 0.15);
  --danger: #dc2626;
  --warning: #d97706;
  --success: #16a34a;
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.08);
  --shadow-lg: 0 10px 30px rgba(0, 0, 0, 0.1);
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  background: var(--bg-primary);
  color: var(--text-primary);
  overflow-x: hidden;
  min-height: 100vh;
}

/* SCROLLBAR STYLING */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: var(--bg-elevated);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--border-hover);
}

/* MODERN APP LAYOUT */
.modern-app {
  display: flex;
  min-height: 100vh;
  position: relative;
}

/* SIDEBAR - Light Glassmorphism */
.sidebar {
  width: 280px;
  min-width: 280px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.92) 0%, rgba(241, 245, 249, 0.95) 100%);
  border-right: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  position: fixed;
  height: 100vh;
  z-index: 100;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(12px);
  box-shadow: var(--shadow-lg);
}

.sidebar.open {
  transform: translateX(0);
}

.sidebar.closed {
  transform: translateX(-100%);
}

.sidebar.collapsed {
  width: 80px;
  min-width: 80px;
}

.sidebar.collapsed .sidebar-text,
.sidebar.collapsed .logo span,
.sidebar.collapsed .sidebar-footer {
  display: none;
}

.sidebar.collapsed .logo {
  justify-content: center;
}

.sidebar.collapsed .menu-item {
  justify-content: center;
  padding: 16px;
}

.sidebar.collapsed .menu-item span {
  font-size: 20px;
}

.sidebar.collapsed .rooms,
.sidebar.collapsed .create-room-btn {
  display: none;
}

/* SIDEBAR HEADER */
.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-color);
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo h2 {
  font-size: 18px;
  font-weight: 700;
  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.logo span {
  transition: all 0.3s;
}

.sidebar-toggle {
  background: var(--bg-elevated);
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  width: 36px;
  height: 36px;
  border-radius: var(--radius-md);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s;
}

.sidebar-toggle:hover {
  background: var(--accent-light);
  border-color: var(--accent-primary);
  color: var(--accent-primary);
  transform: rotate(180deg);
}

/* MENU */
.menu {
  flex: 1 1;
  padding: 20px 12px;
  overflow-y: auto;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 14px 16px;
  background: transparent;
  border: none;
  border-radius: var(--radius-md);
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: left;
  position: relative;
  overflow: hidden;
}

.menu-item::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: var(--accent-glow);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.4s, height 0.4s;
}

.menu-item:hover::before {
  width: 100%;
  height: 100%;
}

.menu-item span {
  font-size: 18px;
  transition: transform 0.2s;
  z-index: 1;
  position: relative;
  width: 24px;
  text-align: center;
}

.menu-item .sidebar-text {
  z-index: 1;
  position: relative;
}

.menu-item:hover {
  color: var(--accent-primary);
  transform: translateX(4px);
}

.menu-item.active {
  background: linear-gradient(135deg, var(--accent-light), #e0e7ff);
  color: var(--accent-primary);
  box-shadow: 0 2px 8px var(--accent-glow);
  font-weight: 600;
}

.menu-item.active span {
  transform: scale(1.2);
}

/* ROOMS SECTION */
.sidebar-footer {
  padding: 20px;
  border-top: 1px solid var(--border-color);
}

.sidebar-footer h4 {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 16px;
}

.rooms {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.room {
  padding: 12px 16px;
  background: var(--bg-elevated);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
}

.room:hover {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
  background: var(--accent-light);
  transform: translateX(4px);
}

.room.active-room {
  background: linear-gradient(135deg, var(--accent-light), #e0e7ff);
  border-color: var(--accent-primary);
  color: var(--accent-primary);
  box-shadow: 0 2px 8px var(--accent-glow);
  font-weight: 600;
}

/* CREATE ROOM BUTTON */
.create-room-btn {
  width: 100%;
  margin-top: 16px;
  padding: 14px;
  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
  border: none;
  border-radius: var(--radius-md);
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.3);
}

.create-room-btn::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.4s, height 0.4s;
}

.create-room-btn:hover::after {
  width: 300px;
  height: 300px;
}

.create-room-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(37, 99, 235, 0.4);
}

.create-room-btn:active {
  transform: translateY(0);
}

/* MAIN CONTENT */
.main-content {
   flex: 1 1;
   margin-left: 0;
   min-height: 100vh;
   background: 
     radial-gradient(ellipse at 20% 0%, rgba(37, 99, 235, 0.06) 0%, transparent 50%),
     radial-gradient(ellipse at 80% 100%, rgba(124, 58, 237, 0.06) 0%, transparent 50%),
     var(--bg-primary);
   display: flex;
   flex-direction: column;
   position: relative;
}

.main-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--border-color), transparent);
  z-index: 1;
}

/* APP HEADER */
.app-header {
  display: flex;
  flex-direction: column;
  padding: 16px 32px 12px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--border-color);
  position: sticky;
  top: 0;
  z-index: 50;
  box-shadow: var(--shadow-sm);
}

.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  flex: 1 1;
}

.meetings-header {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 0 8px;
  border-top: 1px solid var(--border-color);
  min-height: 72px;
  align-items: center;
}

.meeting-name-tag {
  display: inline-block;
  padding: 10px 22px;
  background: var(--bg-elevated);
  border: 1px solid var(--border-color);
  border-radius: 28px;
  font-size: 15px;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
  transition: all 0.2s;
  -webkit-user-select: none;
          user-select: none;
}

.meeting-name-tag:hover {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
  background: var(--accent-light);
}

.meeting-name-tag.active {
  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
  color: white;
  border-color: transparent;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.35);
  transform: translateY(-1px);
  font-weight: 700;
}

.meeting-name-tag.active::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 6px;
  height: 6px;
  background: var(--accent-primary);
  border-radius: 50%;
}

.create-room-section {
  padding: 12px 32px;
  display: flex;
  justify-content: flex-end;
}

.btn-create-room {
  padding: 10px 24px;
  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
  border: none;
  border-radius: var(--radius-md);
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.3);
}

.btn-create-room:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(37, 99, 235, 0.4);
}

.btn-create-room:active {
  transform: translateY(0);
}

.room-description {
  color: var(--text-secondary);
  font-size: 14px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* SEARCH BAR */
.search-bar {
  display: flex;
  align-items: center;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 10px 16px;
  transition: all 0.3s;
}

.search-bar:focus-within {
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px var(--accent-glow);
}

.search-bar input {
  background: transparent;
  border: none;
  outline: none;
  color: var(--text-primary);
  font-size: 14px;
  width: 240px;
  padding: 4px;
}

.search-bar input::placeholder {
  color: var(--text-secondary);
}

.search-btn {
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 16px;
  cursor: pointer;
  padding: 4px;
  transition: color 0.2s;
}

.search-btn:hover {
  color: var(--accent-primary);
}

/* USER PROFILE */
.user-profile {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.user-profile:hover {
  border-color: var(--accent-primary);
}

.user-profile span {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
}

.user-profile img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--accent-primary);
}

/* TABS */
.tabs {
  display: flex;
  gap: 8px;
  padding: 24px 32px 0;
  overflow-x: auto;
  scrollbar-width: none;
}

.tabs::-webkit-scrollbar {
  display: none;
}

.tab-item {
  padding: 12px 24px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
}

.tab-item::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0;
  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
  transition: height 0.3s;
}

.tab-item:hover {
  color: var(--text-primary);
  border-color: var(--accent-primary);
}

.tab-item.active-tab {
  color: var(--accent-primary);
  border-color: var(--accent-primary);
  background: rgba(0, 212, 170, 0.05);
  font-weight: 600;
}

.tab-item.active-tab::before {
  height: 3px;
}

/* CONTENT GRID */
.content {
  display: grid;
  grid-template-columns: 1fr 380px;
  gap: 24px;
  padding: 24px 32px;
  flex: 1 1;
}

/* CARDS */
.card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  padding: 24px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

.card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--accent-primary), var(--accent-secondary));
  opacity: 0;
  transition: opacity 0.3s;
  border-radius: 3px 3px 0 0;
}

.card:hover::before {
  opacity: 1;
}

.card:hover {
  border-color: var(--border-hover);
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

.card h2 {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 12px;
}

.card h3 {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.card p {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.7;
}

.card p strong {
  color: var(--text-primary);
  font-weight: 600;
}

/* BUTTONS */
.button-group {
  display: flex;
  gap: 12px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.btn-primary {
  padding: 14px 28px;
  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
  border: none;
  border-radius: var(--radius-md);
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.3);
}

.btn-primary::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.5s, height 0.5s;
}

.btn-primary:hover::before {
  width: 300px;
  height: 300px;
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(37, 99, 235, 0.4);
}

.btn-primary:active {
  transform: translateY(-1px);
}

.btn-secondary {
  padding: 14px 28px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: var(--shadow-sm);
}

.btn-secondary:hover {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
  background: var(--accent-light);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.btn-secondary:active {
  transform: translateY(0);
}

.btn-full-outline {
  width: 100%;
  padding: 14px;
  background: transparent;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-full-outline:hover {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
  background: var(--accent-light);
  box-shadow: 0 4px 15px var(--accent-glow);
}

.btn-outline {
  padding: 12px 24px;
  background: transparent;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-outline:hover {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
  background: var(--accent-light);
  transform: translateY(-1px);
}

/* STATUS INDICATOR */
.online-indicator {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: rgba(16, 185, 129, 0.1);
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: var(--success);
  border: 1px solid rgba(16, 185, 129, 0.2);
}

.online-indicator::before {
  content: '';
  width: 8px;
  height: 8px;
  background: var(--success);
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.offline-indicator {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: rgba(220, 38, 38, 0.08);
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: var(--danger);
  border: 1px solid rgba(220, 38, 38, 0.15);
}

.offline-indicator::before {
  content: '';
  width: 8px;
  height: 8px;
  background: var(--danger);
  border-radius: 50%;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* MEETING LIST */
.meeting-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
}

.meeting-item {
  padding: 16px;
  background: var(--bg-elevated);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.meeting-item:hover {
  border-color: var(--accent-primary);
  background: var(--accent-light);
  transform: translateX(6px);
}

.meeting-info h3 {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 6px;
}

.meeting-info p {
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-secondary);
}

.meeting-info p span {
  font-size: 14px;
}

/* MEMBERS LIST */
.members-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
}

.member-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px;
  background: var(--bg-elevated);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.member-item:hover {
  border-color: var(--accent-primary);
  background: var(--accent-light);
}

.btn-remove-member {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: none;
  background: var(--danger);
  color: white;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.btn-remove-member:hover {
  background: #b91c1c;
  transform: scale(1.1);
}

.btn-remove-member:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.member-avatar {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}

.member-avatar img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--border-color);
  transition: all 0.2s;
}

.avatar-fallback {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  border: 2px solid var(--border-color);
  flex-shrink: 0;
  -webkit-user-select: none;
          user-select: none;
}

.member-item:hover .member-avatar img {
  border-color: var(--accent-primary);
  transform: scale(1.05);
}

.member-info {
  flex: 1 1;
}

.member-info h3 {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.member-info p {
  font-size: 12px;
  color: var(--text-secondary);
}

/* RIGHT PANEL */
.right-panel {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* LEFT PANEL */
.left-panel {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* HAMBURGER MENU */
.hamburger {
  display: none;
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 24px;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: background 0.2s;
}

.hamburger:hover {
  background: var(--bg-card);
}

/* ENREGISTREMENTS LIST STYLES */
.recordings-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.recording-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background: var(--bg-card);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-color);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.recording-item:hover {
  border-color: var(--accent-primary);
  background: var(--accent-light);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.recording-thumbnail {
  flex: 0 0 80px;
  width: 80px;
  height: 80px;
  border-radius: var(--radius-md);
  background: var(--bg-elevated);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.recording-thumbnail .video-placeholder {
  font-size: 28px;
  color: var(--text-secondary);
}

.recording-thumbnail .duration {
  position: absolute;
  bottom: 4px;
  right: 4px;
  background: rgba(0,0,0,0.6);
  color: white;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}

.recording-info {
  flex: 1 1;
  margin-left: 20px;
}

.recording-info h3 {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

.recording-info p {
  margin: 4px 0;
  font-size: 14px;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  gap: 6px;
}

.recording-info p span {
  font-size: 16px;
}

.button-group {
  display: flex;
  gap: 10px;
}

.button-group .btn-outline,
.button-group .btn-primary {
  flex: 1 1;
}

/* RESPONSIVE */
@media (max-width: 1024px) {
  .content {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .right-panel {
    order: -1;
  }
}

@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-100%);
  }
  
  .sidebar.open {
    transform: translateX(0);
  }
  
  .main-content {
    margin-left: 0;
  }
  
  .app-header {
    padding: 16px 20px;
    flex-wrap: wrap;
  }
  
  .header-left h1 {
    font-size: 20px;
  }
  
  .search-bar {
    width: 100%;
  }
  
  .search-bar input {
    width: 100%;
  }
  
  .content {
    padding: 16px 20px;
  }
  
  .tabs {
    padding: 16px 20px 0;
    gap: 6px;
  }
  
  .tab-item {
    padding: 10px 16px;
    font-size: 13px;
  }
  
  .card {
    padding: 20px;
  }
  
  .hamburger {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
  }
  
  .button-group {
    flex-direction: column;
  }
  
  .btn-primary, .btn-secondary {
    width: 100%;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .app-header {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
  
  .header-right {
    flex-direction: column;
    width: 100%;
  }
  
  .search-bar {
    width: 100%;
  }
  
  .search-bar input {
    width: 100%;
  }
  
  .user-profile {
    justify-content: center;
    width: 100%;
  }
  
  .user-profile span {
    display: none;
  }
  
  .content {
    padding: 12px 16px;
    gap: 16px;
  }
  
  .card {
    padding: 16px;
  }
  
  .tabs {
    padding: 12px 16px 0;
  }
  
  .sidebar.collapsed .menu-item {
    padding: 14px;
  }
}

/* ANIMATION UTILITIES */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.card {
  animation: fadeInUp 0.5s ease-out forwards;
}

.sidebar .menu-item {
  animation: slideInLeft 0.3s ease-out forwards;
}

.sidebar .menu-item:nth-child(1) { animation-delay: 0.05s; }
.sidebar .menu-item:nth-child(2) { animation-delay: 0.1s; }
.sidebar .menu-item:nth-child(3) { animation-delay: 0.15s; }
.sidebar .menu-item:nth-child(4) { animation-delay: 0.2s; }
.sidebar .menu-item:nth-child(5) { animation-delay: 0.25s; }
.sidebar .menu-item:nth-child(6) { animation-delay: 0.3s; }
.sidebar .menu-item:nth-child(7) { animation-delay: 0.35s; }

/* FOCUS STATES */
button:focus-visible,
input:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: 2px;
}

/* REDUCED MOTION */
/* ══════════════════════════════════════════════════════
   BASE LAYOUT FIX — s'assure que modern-app est column
══════════════════════════════════════════════════════ */
.modern-app {
  flex-direction: column;
}

/* ══════════════════════════════════════════════════════
   RESPONSIVE — 1024px : on bascule left/right en 1 colonne
══════════════════════════════════════════════════════ */
@media (max-width: 1024px) {
  .app-header {
    padding: 14px 20px 10px;
  }

  .meetings-header {
    padding: 10px 0 6px;
    gap: 8px;
  }

  .meeting-name-tag {
    padding: 8px 16px;
    font-size: 13px;
  }

  .create-room-section {
    padding: 10px 20px;
  }

  .content {
    grid-template-columns: 1fr;
    padding: 16px 20px;
    gap: 16px;
  }

  .right-panel {
    order: -1; /* salle-info en haut sur mobile */
  }
}

/* ══════════════════════════════════════════════════════
   RESPONSIVE — 768px : sidebar cachée, header tactile
══════════════════════════════════════════════════════ */
@media (max-width: 768px) {
  .sidebar {
    display: none;
  }

  .main-content {
    width: 100%;
    min-width: 0;
  }

  .app-header {
    padding: 12px 16px;
    gap: 12px;
  }

  .header-top {
    flex-wrap: nowrap;
  }

  .header-left {
    flex: 1 1;
    min-width: 0;
    margin-right: 8px;
  }

  .header-right {
    flex-wrap: nowrap;
    gap: 8px;
    flex-shrink: 0;
  }

  .search-bar {
    width: auto;
    min-width: 36px;
    padding: 8px 10px;
  }

  .search-bar input {
    width: 120px;
    font-size: 13px;
  }

  .user-profile {
    gap: 6px;
    padding: 6px 8px;
  }

  .user-profile span {
    display: none;
  }

  .user-profile img {
    width: 32px;
    height: 32px;
  }

  /* Tags des salles : scroll horizontal */
  .meetings-header {
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    padding: 8px 0;
    gap: 8px;
    margin: 0 -8px;
    padding-left: 16px;
    padding-right: 16px;
  }

  .meetings-header::-webkit-scrollbar {
    display: none;
  }

  .meeting-name-tag {
    flex-shrink: 0;
    padding: 6px 14px;
    font-size: 13px;
    white-space: nowrap;
  }

  /* Créer salle */
  .btn-create-room {
    padding: 8px 18px;
    font-size: 13px;
  }

  /* Tabs */
  .tabs {
    padding: 12px 16px 0;
    gap: 4px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    margin: 0 -4px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .tabs::-webkit-scrollbar {
    display: none;
  }

  .tab-item {
    flex-shrink: 0;
    padding: 10px 14px;
    font-size: 13px;
    line-height: 1.2;
  }

  /* Content */
  .content {
    padding: 12px 16px;
    gap: 12px;
  }

  /* Cards */
  .card {
    padding: 16px;
    border-radius: var(--radius-md);
  }

  .card h2 {
    font-size: 16px;
  }

  .card h3 {
    font-size: 14px;
  }

  .card p {
    font-size: 13px;
    line-height: 1.6;
  }

  /* Recording items — stack image above text */
  .recording-item {
    flex-direction: column;
    gap: 10px;
  }

  .recording-thumbnail img {
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;
  }

  .recording-info .button-group {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .recording-info button {
    width: 100%;
    text-align: center;
  }

  /* File items — stack icon on top */
  .file-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .file-icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }

  .file-item .btn-outline {
    width: 100%;
    text-align: center;
  }

  /* Settings items — stack toggle */
  .setting-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  /* Members */
  .member-item {
    padding: 10px;
    gap: 10px;
  }

  .member-avatar img {
    width: 36px;
    height: 36px;
  }

  /* Buttons full-width */
  .button-group {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-primary,
  .btn-secondary,
  .btn-outline {
    width: 100%;
    text-align: center;
    padding: 12px;
    font-size: 14px;
  }

  .btn-full-outline {
    padding: 12px;
    font-size: 13px;
  }

  /* Meeting list items */
  .meeting-item {
    padding: 12px;
  }

  /* Modal */
  .modal-content {
    width: 95%;
    margin: 16px;
    max-height: 90vh;
    overflow-y: auto;
    padding: 20px;
  }

  .modal-header h3 {
    font-size: 17px;
  }

  /* Chat room (mode page) */
  .left-panel > div,
  .left-panel iframe {
    max-height: 65vh;
  }

  /* Prevent horizontal scroll on entire page */
  body {
    overflow-x: hidden;
  }
}

/* ══════════════════════════════════════════════════════
   RESPONSIVE — 480px : très petit écran
══════════════════════════════════════════════════════ */
@media (max-width: 480px) {
  .app-header {
    padding: 10px 12px;
  }

  .header-left {
    margin-right: 0;
  }

  .header-right {
    gap: 4px;
  }

  .search-bar input {
    width: 80px;
    font-size: 12px;
  }

  .search-bar input::placeholder {
    font-size: 12px;
  }

  .meetings-header {
    padding-left: 12px;
    padding-right: 12px;
  }

  .meeting-name-tag {
    padding: 5px 10px;
    font-size: 12px;
    font-weight: 400;
  }

  .tabs {
    padding-left: 12px;
    padding-right: 4px;
  }

  .tab-item {
    padding: 8px 10px;
    font-size: 12px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .content {
    padding: 10px 12px;
    gap: 10px;
  }

  .card {
    padding: 14px;
  }

  .card h2 {
    font-size: 15px;
  }

  .card p {
    font-size: 12px;
  }

  .btn-primary,
  .btn-secondary {
    padding: 11px 16px;
    font-size: 13px;
  }

  .modal-content {
    padding: 16px;
    width: 92%;
  }

  .invite-modal-form .form-group input,
  .create-room-form .form-group input,
  .create-room-form .form-group textarea,
  .create-room-form .form-group select {
    padding: 10px 12px;
    font-size: 13px;
  }
}

/* ══════════════════════════════════════════════════════
   REDUCED MOTION
══════════════════════════════════════════════════════ */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* TOGGLE SWITCH */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--border-color);
  border-radius: 24px;
  transition: 0.3s;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: white;
  border-radius: 50%;
  transition: 0.3s;
  box-shadow: var(--shadow-sm);
}

.toggle-switch input:checked + .toggle-slider {
  background: var(--accent-primary);
}

.toggle-switch input:checked + .toggle-slider:before {
  transform: translateX(24px);
}

/* ROOM ACTIONS BUTTONS */
.card-header-with-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.room-actions {
  display: flex;
  gap: 8px;
}

.btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: transparent;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-icon:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.btn-edit:hover {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
  background: var(--accent-light);
}

.btn-delete:hover {
  border-color: var(--danger);
  color: var(--danger);
  background: rgba(220, 38, 38, 0.08);
}

.btn-icon:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Video Player Styles for Recordings */
.video-player-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.video-player-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.recording-video-player {
  width: 100%;
  max-height: 400px;
  border-radius: var(--radius-md);
  background: var(--bg-elevated);
}

.recording-info-full {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background: var(--bg-elevated);
  border-radius: var(--radius-md);
}

.recording-info-full p {
  margin: 4px 0;
  font-size: 14px;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  gap: 6px;
}

.recording-info-full p span {
  font-size: 16px;
}

.recording-actions {
  display: flex;
  gap: 8px;
}

.btn-delete-recording {
  background: var(--danger) !important;
  color: white !important;
  border-color: var(--danger) !important;
}

.btn-delete-recording:hover {
   background: #b91c1c !important;
   border-color: #b91c1c !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/salle.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,2CAA2C;EAC3C,2CAA2C;EAC3C,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mEAAmE;EACnE,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,gBAAgB;EAChB,iGAAiG;EACjG,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,gGAAgG;EAChG,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mFAAmF;EACnF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,iEAAiE;EACjE,4BAA4B;EAC5B,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,iEAAiE;EACjE,mCAAmC;EACnC,4BAA4B;EAC5B,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mFAAmF;EACnF,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;GACG,SAAO;GACP,cAAc;GACd,iBAAiB;GACjB;;;sBAGmB;GACnB,aAAa;GACb,sBAAsB;GACtB,kBAAkB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iFAAiF;EACjF,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,2BAA2B;EAC3B,4CAA4C;EAC5C,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,mFAAmF;EACnF,YAAY;EACZ,yBAAyB;EACzB,8CAA8C;EAC9C,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mFAAmF;EACnF,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,0BAA0B;EAC1B,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,qCAAqC;EACrC,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,SAAS;EACT,mFAAmF;EACnF,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,SAAO;AACT;;AAEA,UAAU;AACV;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,kFAAkF;EAClF,UAAU;EACV,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mFAAmF;EACnF,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mFAAmF;EACnF,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,SAAO;AACT;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,qBAAqB,EAAE;AAC1D,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,qBAAqB,EAAE;AAC1D,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,qBAAqB,EAAE;AAC1D,mCAAmC,sBAAsB,EAAE;;AAE3D,iBAAiB;AACjB;;EAEE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;;wDAEwD;AACxD;EACE,sBAAsB;AACxB;;AAEA;;wDAEwD;AACxD;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,SAAS,EAAE,kCAAkC;EAC/C;AACF;;AAEA;;wDAEwD;AACxD;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,wCAAwC;EACxC;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,qBAAqB;IACrB,cAAc;IACd,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;;EAEA,gBAAgB;EAChB;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA,SAAS;EACT;IACE,oBAAoB;IACpB,QAAQ;IACR,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA,YAAY;EACZ;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA,UAAU;EACV;IACE,aAAa;IACb,+BAA+B;EACjC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,6CAA6C;EAC7C;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA,mCAAmC;EACnC;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA,kCAAkC;EAClC;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA,YAAY;EACZ;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,uBAAuB;EACvB;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;;IAGE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA,uBAAuB;EACvB;IACE,aAAa;EACf;;EAEA,UAAU;EACV;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA,0BAA0B;EAC1B;;IAEE,gBAAgB;EAClB;;EAEA,6CAA6C;EAC7C;IACE,kBAAkB;EACpB;AACF;;AAEA;;wDAEwD;AACxD;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;;;;IAIE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;;wDAEwD;AACxD;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;GACG,8BAA8B;GAC9B,gCAAgC;AACnC","sourcesContent":["/* 🎨 SALLE DE RÉUNION - DESIGN MODERNE & LUMINEUX */\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n:root {\r\n  --bg-primary: #f8fafc;\r\n  --bg-secondary: #ffffff;\r\n  --bg-card: #ffffff;\r\n  --bg-elevated: #f1f5f9;\r\n  --border-color: #e2e8f0;\r\n  --border-hover: #cbd5e1;\r\n  --text-primary: #1e293b;\r\n  --text-secondary: #64748b;\r\n  --text-muted: #94a3b8;\r\n  --accent-primary: #2563eb;\r\n  --accent-secondary: #7c3aed;\r\n  --accent-light: #dbeafe;\r\n  --accent-glow: rgba(37, 99, 235, 0.15);\r\n  --danger: #dc2626;\r\n  --warning: #d97706;\r\n  --success: #16a34a;\r\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);\r\n  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.08);\r\n  --shadow-lg: 0 10px 30px rgba(0, 0, 0, 0.1);\r\n  --radius-sm: 8px;\r\n  --radius-md: 12px;\r\n  --radius-lg: 16px;\r\n}\r\n\r\nbody {\r\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\r\n  background: var(--bg-primary);\r\n  color: var(--text-primary);\r\n  overflow-x: hidden;\r\n  min-height: 100vh;\r\n}\r\n\r\n/* SCROLLBAR STYLING */\r\n::-webkit-scrollbar {\r\n  width: 6px;\r\n  height: 6px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: var(--bg-elevated);\r\n  border-radius: 3px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: var(--border-color);\r\n  border-radius: 3px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: var(--border-hover);\r\n}\r\n\r\n/* MODERN APP LAYOUT */\r\n.modern-app {\r\n  display: flex;\r\n  min-height: 100vh;\r\n  position: relative;\r\n}\r\n\r\n/* SIDEBAR - Light Glassmorphism */\r\n.sidebar {\r\n  width: 280px;\r\n  min-width: 280px;\r\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.92) 0%, rgba(241, 245, 249, 0.95) 100%);\r\n  border-right: 1px solid var(--border-color);\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: fixed;\r\n  height: 100vh;\r\n  z-index: 100;\r\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  backdrop-filter: blur(12px);\r\n  box-shadow: var(--shadow-lg);\r\n}\r\n\r\n.sidebar.open {\r\n  transform: translateX(0);\r\n}\r\n\r\n.sidebar.closed {\r\n  transform: translateX(-100%);\r\n}\r\n\r\n.sidebar.collapsed {\r\n  width: 80px;\r\n  min-width: 80px;\r\n}\r\n\r\n.sidebar.collapsed .sidebar-text,\r\n.sidebar.collapsed .logo span,\r\n.sidebar.collapsed .sidebar-footer {\r\n  display: none;\r\n}\r\n\r\n.sidebar.collapsed .logo {\r\n  justify-content: center;\r\n}\r\n\r\n.sidebar.collapsed .menu-item {\r\n  justify-content: center;\r\n  padding: 16px;\r\n}\r\n\r\n.sidebar.collapsed .menu-item span {\r\n  font-size: 20px;\r\n}\r\n\r\n.sidebar.collapsed .rooms,\r\n.sidebar.collapsed .create-room-btn {\r\n  display: none;\r\n}\r\n\r\n/* SIDEBAR HEADER */\r\n.sidebar-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 20px 24px;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.logo {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.logo h2 {\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n.logo span {\r\n  transition: all 0.3s;\r\n}\r\n\r\n.sidebar-toggle {\r\n  background: var(--bg-elevated);\r\n  border: 1px solid var(--border-color);\r\n  color: var(--text-secondary);\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: var(--radius-md);\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 14px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.sidebar-toggle:hover {\r\n  background: var(--accent-light);\r\n  border-color: var(--accent-primary);\r\n  color: var(--accent-primary);\r\n  transform: rotate(180deg);\r\n}\r\n\r\n/* MENU */\r\n.menu {\r\n  flex: 1;\r\n  padding: 20px 12px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.menu-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  width: 100%;\r\n  padding: 14px 16px;\r\n  background: transparent;\r\n  border: none;\r\n  border-radius: var(--radius-md);\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\r\n  text-align: left;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.menu-item::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 0;\r\n  height: 0;\r\n  background: var(--accent-glow);\r\n  border-radius: 50%;\r\n  transform: translate(-50%, -50%);\r\n  transition: width 0.4s, height 0.4s;\r\n}\r\n\r\n.menu-item:hover::before {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.menu-item span {\r\n  font-size: 18px;\r\n  transition: transform 0.2s;\r\n  z-index: 1;\r\n  position: relative;\r\n  width: 24px;\r\n  text-align: center;\r\n}\r\n\r\n.menu-item .sidebar-text {\r\n  z-index: 1;\r\n  position: relative;\r\n}\r\n\r\n.menu-item:hover {\r\n  color: var(--accent-primary);\r\n  transform: translateX(4px);\r\n}\r\n\r\n.menu-item.active {\r\n  background: linear-gradient(135deg, var(--accent-light), #e0e7ff);\r\n  color: var(--accent-primary);\r\n  box-shadow: 0 2px 8px var(--accent-glow);\r\n  font-weight: 600;\r\n}\r\n\r\n.menu-item.active span {\r\n  transform: scale(1.2);\r\n}\r\n\r\n/* ROOMS SECTION */\r\n.sidebar-footer {\r\n  padding: 20px;\r\n  border-top: 1px solid var(--border-color);\r\n}\r\n\r\n.sidebar-footer h4 {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: var(--text-muted);\r\n  text-transform: uppercase;\r\n  letter-spacing: 1.5px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.rooms {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.room {\r\n  padding: 12px 16px;\r\n  background: var(--bg-elevated);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: var(--radius-sm);\r\n  color: var(--text-secondary);\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  text-align: left;\r\n}\r\n\r\n.room:hover {\r\n  border-color: var(--accent-primary);\r\n  color: var(--accent-primary);\r\n  background: var(--accent-light);\r\n  transform: translateX(4px);\r\n}\r\n\r\n.room.active-room {\r\n  background: linear-gradient(135deg, var(--accent-light), #e0e7ff);\r\n  border-color: var(--accent-primary);\r\n  color: var(--accent-primary);\r\n  box-shadow: 0 2px 8px var(--accent-glow);\r\n  font-weight: 600;\r\n}\r\n\r\n/* CREATE ROOM BUTTON */\r\n.create-room-btn {\r\n  width: 100%;\r\n  margin-top: 16px;\r\n  padding: 14px;\r\n  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));\r\n  border: none;\r\n  border-radius: var(--radius-md);\r\n  color: white;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n  position: relative;\r\n  overflow: hidden;\r\n  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.3);\r\n}\r\n\r\n.create-room-btn::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 0;\r\n  height: 0;\r\n  background: rgba(255, 255, 255, 0.3);\r\n  border-radius: 50%;\r\n  transform: translate(-50%, -50%);\r\n  transition: width 0.4s, height 0.4s;\r\n}\r\n\r\n.create-room-btn:hover::after {\r\n  width: 300px;\r\n  height: 300px;\r\n}\r\n\r\n.create-room-btn:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 30px rgba(37, 99, 235, 0.4);\r\n}\r\n\r\n.create-room-btn:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n/* MAIN CONTENT */\r\n.main-content {\r\n   flex: 1;\r\n   margin-left: 0;\r\n   min-height: 100vh;\r\n   background: \r\n     radial-gradient(ellipse at 20% 0%, rgba(37, 99, 235, 0.06) 0%, transparent 50%),\r\n     radial-gradient(ellipse at 80% 100%, rgba(124, 58, 237, 0.06) 0%, transparent 50%),\r\n     var(--bg-primary);\r\n   display: flex;\r\n   flex-direction: column;\r\n   position: relative;\r\n}\n\r\n.main-content::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 1px;\r\n  background: linear-gradient(90deg, transparent, var(--border-color), transparent);\r\n  z-index: 1;\r\n}\r\n\r\n/* APP HEADER */\r\n.app-header {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 16px 32px 12px;\r\n  background: rgba(255, 255, 255, 0.7);\r\n  backdrop-filter: blur(12px);\r\n  border-bottom: 1px solid var(--border-color);\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 50;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.header-top {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.header-left {\r\n  flex: 1;\r\n}\r\n\r\n.meetings-header {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 12px;\r\n  padding: 14px 0 8px;\r\n  border-top: 1px solid var(--border-color);\r\n  min-height: 72px;\r\n  align-items: center;\r\n}\r\n\r\n.meeting-name-tag {\r\n  display: inline-block;\r\n  padding: 10px 22px;\r\n  background: var(--bg-elevated);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 28px;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  position: relative;\r\n  transition: all 0.2s ease;\r\n  transition: all 0.2s;\r\n  user-select: none;\r\n}\r\n\r\n.meeting-name-tag:hover {\r\n  border-color: var(--accent-primary);\r\n  color: var(--accent-primary);\r\n  background: var(--accent-light);\r\n}\r\n\r\n.meeting-name-tag.active {\r\n  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));\r\n  color: white;\r\n  border-color: transparent;\r\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.35);\r\n  transform: translateY(-1px);\r\n  font-weight: 700;\r\n}\r\n\r\n.meeting-name-tag.active::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: -8px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 6px;\r\n  height: 6px;\r\n  background: var(--accent-primary);\r\n  border-radius: 50%;\r\n}\r\n\r\n.create-room-section {\r\n  padding: 12px 32px;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.btn-create-room {\r\n  padding: 10px 24px;\r\n  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));\r\n  border: none;\r\n  border-radius: var(--radius-md);\r\n  color: white;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.3);\r\n}\r\n\r\n.btn-create-room:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 25px rgba(37, 99, 235, 0.4);\r\n}\r\n\r\n.btn-create-room:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.room-description {\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n}\r\n\r\n.header-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n}\r\n\r\n/* SEARCH BAR */\r\n.search-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 12px;\r\n  padding: 10px 16px;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.search-bar:focus-within {\r\n  border-color: var(--accent-primary);\r\n  box-shadow: 0 0 0 3px var(--accent-glow);\r\n}\r\n\r\n.search-bar input {\r\n  background: transparent;\r\n  border: none;\r\n  outline: none;\r\n  color: var(--text-primary);\r\n  font-size: 14px;\r\n  width: 240px;\r\n  padding: 4px;\r\n}\r\n\r\n.search-bar input::placeholder {\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.search-btn {\r\n  background: none;\r\n  border: none;\r\n  color: var(--text-secondary);\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  padding: 4px;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.search-btn:hover {\r\n  color: var(--accent-primary);\r\n}\r\n\r\n/* USER PROFILE */\r\n.user-profile {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 8px 12px;\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.user-profile:hover {\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.user-profile span {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.user-profile img {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n  border: 2px solid var(--accent-primary);\r\n}\r\n\r\n/* TABS */\r\n.tabs {\r\n  display: flex;\r\n  gap: 8px;\r\n  padding: 24px 32px 0;\r\n  overflow-x: auto;\r\n  scrollbar-width: none;\r\n}\r\n\r\n.tabs::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.tab-item {\r\n  padding: 12px 24px;\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 10px;\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n  white-space: nowrap;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.tab-item::before {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 0;\r\n  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));\r\n  transition: height 0.3s;\r\n}\r\n\r\n.tab-item:hover {\r\n  color: var(--text-primary);\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.tab-item.active-tab {\r\n  color: var(--accent-primary);\r\n  border-color: var(--accent-primary);\r\n  background: rgba(0, 212, 170, 0.05);\r\n  font-weight: 600;\r\n}\r\n\r\n.tab-item.active-tab::before {\r\n  height: 3px;\r\n}\r\n\r\n/* CONTENT GRID */\r\n.content {\r\n  display: grid;\r\n  grid-template-columns: 1fr 380px;\r\n  gap: 24px;\r\n  padding: 24px 32px;\r\n  flex: 1;\r\n}\r\n\r\n/* CARDS */\r\n.card {\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: var(--radius-lg);\r\n  padding: 24px;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  position: relative;\r\n  overflow: hidden;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.card::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 3px;\r\n  background: linear-gradient(90deg, var(--accent-primary), var(--accent-secondary));\r\n  opacity: 0;\r\n  transition: opacity 0.3s;\r\n  border-radius: 3px 3px 0 0;\r\n}\r\n\r\n.card:hover::before {\r\n  opacity: 1;\r\n}\r\n\r\n.card:hover {\r\n  border-color: var(--border-hover);\r\n  transform: translateY(-4px);\r\n  box-shadow: var(--shadow-lg);\r\n}\r\n\r\n.card h2 {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.card h3 {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.card p {\r\n  font-size: 14px;\r\n  color: var(--text-secondary);\r\n  line-height: 1.7;\r\n}\r\n\r\n.card p strong {\r\n  color: var(--text-primary);\r\n  font-weight: 600;\r\n}\r\n\r\n/* BUTTONS */\r\n.button-group {\r\n  display: flex;\r\n  gap: 12px;\r\n  margin-top: 20px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.btn-primary {\r\n  padding: 14px 28px;\r\n  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));\r\n  border: none;\r\n  border-radius: var(--radius-md);\r\n  color: white;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  position: relative;\r\n  overflow: hidden;\r\n  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.3);\r\n}\r\n\r\n.btn-primary::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 0;\r\n  height: 0;\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border-radius: 50%;\r\n  transform: translate(-50%, -50%);\r\n  transition: width 0.5s, height 0.5s;\r\n}\r\n\r\n.btn-primary:hover::before {\r\n  width: 300px;\r\n  height: 300px;\r\n}\r\n\r\n.btn-primary:hover {\r\n  transform: translateY(-3px);\r\n  box-shadow: 0 8px 25px rgba(37, 99, 235, 0.4);\r\n}\r\n\r\n.btn-primary:active {\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.btn-secondary {\r\n  padding: 14px 28px;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: var(--radius-md);\r\n  color: var(--text-primary);\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.btn-secondary:hover {\r\n  border-color: var(--accent-primary);\r\n  color: var(--accent-primary);\r\n  background: var(--accent-light);\r\n  transform: translateY(-2px);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.btn-secondary:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.btn-full-outline {\r\n  width: 100%;\r\n  padding: 14px;\r\n  background: transparent;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: var(--radius-md);\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  margin-top: 16px;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.btn-full-outline:hover {\r\n  border-color: var(--accent-primary);\r\n  color: var(--accent-primary);\r\n  background: var(--accent-light);\r\n  box-shadow: 0 4px 15px var(--accent-glow);\r\n}\r\n\r\n.btn-outline {\r\n  padding: 12px 24px;\r\n  background: transparent;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: var(--radius-sm);\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.btn-outline:hover {\r\n  border-color: var(--accent-primary);\r\n  color: var(--accent-primary);\r\n  background: var(--accent-light);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n/* STATUS INDICATOR */\r\n.online-indicator {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 12px;\r\n  background: rgba(16, 185, 129, 0.1);\r\n  border-radius: 20px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: var(--success);\r\n  border: 1px solid rgba(16, 185, 129, 0.2);\r\n}\r\n\r\n.online-indicator::before {\r\n  content: '';\r\n  width: 8px;\r\n  height: 8px;\r\n  background: var(--success);\r\n  border-radius: 50%;\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n.offline-indicator {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 12px;\r\n  background: rgba(220, 38, 38, 0.08);\r\n  border-radius: 20px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: var(--danger);\r\n  border: 1px solid rgba(220, 38, 38, 0.15);\r\n}\r\n\r\n.offline-indicator::before {\r\n  content: '';\r\n  width: 8px;\r\n  height: 8px;\r\n  background: var(--danger);\r\n  border-radius: 50%;\r\n}\r\n\r\n@keyframes pulse {\r\n  0%, 100% { opacity: 1; }\r\n  50% { opacity: 0.5; }\r\n}\r\n\r\n/* MEETING LIST */\r\n.meeting-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  margin-top: 16px;\r\n}\r\n\r\n.meeting-item {\r\n  padding: 16px;\r\n  background: var(--bg-elevated);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: var(--radius-md);\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.meeting-item:hover {\r\n  border-color: var(--accent-primary);\r\n  background: var(--accent-light);\r\n  transform: translateX(6px);\r\n}\r\n\r\n.meeting-info h3 {\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.meeting-info p {\r\n  font-size: 13px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.meeting-info p span {\r\n  font-size: 14px;\r\n}\r\n\r\n/* MEMBERS LIST */\r\n.members-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  margin-top: 16px;\r\n}\r\n\r\n.member-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  padding: 12px;\r\n  background: var(--bg-elevated);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: var(--radius-md);\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.member-item:hover {\r\n  border-color: var(--accent-primary);\r\n  background: var(--accent-light);\r\n}\r\n\r\n.btn-remove-member {\r\n  flex-shrink: 0;\r\n  width: 34px;\r\n  height: 34px;\r\n  border-radius: 50%;\r\n  border: none;\r\n  background: var(--danger);\r\n  color: white;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.btn-remove-member:hover {\r\n  background: #b91c1c;\r\n  transform: scale(1.1);\r\n}\r\n\r\n.btn-remove-member:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n  transform: none;\r\n}\r\n\r\n.member-avatar {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.member-avatar img {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n  border: 2px solid var(--border-color);\r\n  transition: all 0.2s;\r\n}\r\n\r\n.avatar-fallback {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 50%;\r\n  background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));\r\n  color: white;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  border: 2px solid var(--border-color);\r\n  flex-shrink: 0;\r\n  user-select: none;\r\n}\r\n\r\n.member-item:hover .member-avatar img {\r\n  border-color: var(--accent-primary);\r\n  transform: scale(1.05);\r\n}\r\n\r\n.member-info {\r\n  flex: 1;\r\n}\r\n\r\n.member-info h3 {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.member-info p {\r\n  font-size: 12px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* RIGHT PANEL */\r\n.right-panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n/* LEFT PANEL */\r\n.left-panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n/* HAMBURGER MENU */\r\n.hamburger {\r\n  display: none;\r\n  background: none;\r\n  border: none;\r\n  color: var(--text-primary);\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  padding: 8px;\r\n  border-radius: 8px;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.hamburger:hover {\r\n  background: var(--bg-card);\r\n}\r\n\r\n/* ENREGISTREMENTS LIST STYLES */\r\n.recordings-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.recording-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px 24px;\r\n  background: var(--bg-card);\r\n  border-radius: var(--radius-lg);\r\n  border: 1px solid var(--border-color);\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.recording-item:hover {\r\n  border-color: var(--accent-primary);\r\n  background: var(--accent-light);\r\n  transform: translateY(-2px);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.recording-thumbnail {\r\n  flex: 0 0 80px;\r\n  width: 80px;\r\n  height: 80px;\r\n  border-radius: var(--radius-md);\r\n  background: var(--bg-elevated);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  position: relative;\r\n}\r\n\r\n.recording-thumbnail .video-placeholder {\r\n  font-size: 28px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.recording-thumbnail .duration {\r\n  position: absolute;\r\n  bottom: 4px;\r\n  right: 4px;\r\n  background: rgba(0,0,0,0.6);\r\n  color: white;\r\n  font-size: 12px;\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.recording-info {\r\n  flex: 1;\r\n  margin-left: 20px;\r\n}\r\n\r\n.recording-info h3 {\r\n  margin: 0 0 8px 0;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.recording-info p {\r\n  margin: 4px 0;\r\n  font-size: 14px;\r\n  color: var(--text-secondary);\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.recording-info p span {\r\n  font-size: 16px;\r\n}\r\n\r\n.button-group {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.button-group .btn-outline,\r\n.button-group .btn-primary {\r\n  flex: 1;\r\n}\r\n\r\n/* RESPONSIVE */\r\n@media (max-width: 1024px) {\r\n  .content {\r\n    grid-template-columns: 1fr;\r\n    gap: 20px;\r\n  }\r\n  \r\n  .right-panel {\r\n    order: -1;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .sidebar {\r\n    transform: translateX(-100%);\r\n  }\r\n  \r\n  .sidebar.open {\r\n    transform: translateX(0);\r\n  }\r\n  \r\n  .main-content {\r\n    margin-left: 0;\r\n  }\r\n  \r\n  .app-header {\r\n    padding: 16px 20px;\r\n    flex-wrap: wrap;\r\n  }\r\n  \r\n  .header-left h1 {\r\n    font-size: 20px;\r\n  }\r\n  \r\n  .search-bar {\r\n    width: 100%;\r\n  }\r\n  \r\n  .search-bar input {\r\n    width: 100%;\r\n  }\r\n  \r\n  .content {\r\n    padding: 16px 20px;\r\n  }\r\n  \r\n  .tabs {\r\n    padding: 16px 20px 0;\r\n    gap: 6px;\r\n  }\r\n  \r\n  .tab-item {\r\n    padding: 10px 16px;\r\n    font-size: 13px;\r\n  }\r\n  \r\n  .card {\r\n    padding: 20px;\r\n  }\r\n  \r\n  .hamburger {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-right: 12px;\r\n  }\r\n  \r\n  .button-group {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .btn-primary, .btn-secondary {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .app-header {\r\n    flex-direction: column;\r\n    gap: 16px;\r\n    align-items: stretch;\r\n  }\r\n  \r\n  .header-right {\r\n    flex-direction: column;\r\n    width: 100%;\r\n  }\r\n  \r\n  .search-bar {\r\n    width: 100%;\r\n  }\r\n  \r\n  .search-bar input {\r\n    width: 100%;\r\n  }\r\n  \r\n  .user-profile {\r\n    justify-content: center;\r\n    width: 100%;\r\n  }\r\n  \r\n  .user-profile span {\r\n    display: none;\r\n  }\r\n  \r\n  .content {\r\n    padding: 12px 16px;\r\n    gap: 16px;\r\n  }\r\n  \r\n  .card {\r\n    padding: 16px;\r\n  }\r\n  \r\n  .tabs {\r\n    padding: 12px 16px 0;\r\n  }\r\n  \r\n  .sidebar.collapsed .menu-item {\r\n    padding: 14px;\r\n  }\r\n}\r\n\r\n/* ANIMATION UTILITIES */\r\n@keyframes fadeInUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes slideInLeft {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(-20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n.card {\r\n  animation: fadeInUp 0.5s ease-out forwards;\r\n}\r\n\r\n.sidebar .menu-item {\r\n  animation: slideInLeft 0.3s ease-out forwards;\r\n}\r\n\r\n.sidebar .menu-item:nth-child(1) { animation-delay: 0.05s; }\r\n.sidebar .menu-item:nth-child(2) { animation-delay: 0.1s; }\r\n.sidebar .menu-item:nth-child(3) { animation-delay: 0.15s; }\r\n.sidebar .menu-item:nth-child(4) { animation-delay: 0.2s; }\r\n.sidebar .menu-item:nth-child(5) { animation-delay: 0.25s; }\r\n.sidebar .menu-item:nth-child(6) { animation-delay: 0.3s; }\r\n.sidebar .menu-item:nth-child(7) { animation-delay: 0.35s; }\r\n\r\n/* FOCUS STATES */\r\nbutton:focus-visible,\r\ninput:focus-visible {\r\n  outline: 2px solid var(--accent-primary);\r\n  outline-offset: 2px;\r\n}\r\n\r\n/* REDUCED MOTION */\r\n/* ══════════════════════════════════════════════════════\r\n   BASE LAYOUT FIX — s'assure que modern-app est column\r\n══════════════════════════════════════════════════════ */\r\n.modern-app {\r\n  flex-direction: column;\r\n}\r\n\r\n/* ══════════════════════════════════════════════════════\r\n   RESPONSIVE — 1024px : on bascule left/right en 1 colonne\r\n══════════════════════════════════════════════════════ */\r\n@media (max-width: 1024px) {\r\n  .app-header {\r\n    padding: 14px 20px 10px;\r\n  }\r\n\r\n  .meetings-header {\r\n    padding: 10px 0 6px;\r\n    gap: 8px;\r\n  }\r\n\r\n  .meeting-name-tag {\r\n    padding: 8px 16px;\r\n    font-size: 13px;\r\n  }\r\n\r\n  .create-room-section {\r\n    padding: 10px 20px;\r\n  }\r\n\r\n  .content {\r\n    grid-template-columns: 1fr;\r\n    padding: 16px 20px;\r\n    gap: 16px;\r\n  }\r\n\r\n  .right-panel {\r\n    order: -1; /* salle-info en haut sur mobile */\r\n  }\r\n}\r\n\r\n/* ══════════════════════════════════════════════════════\r\n   RESPONSIVE — 768px : sidebar cachée, header tactile\r\n══════════════════════════════════════════════════════ */\r\n@media (max-width: 768px) {\r\n  .sidebar {\r\n    display: none;\r\n  }\r\n\r\n  .main-content {\r\n    width: 100%;\r\n    min-width: 0;\r\n  }\r\n\r\n  .app-header {\r\n    padding: 12px 16px;\r\n    gap: 12px;\r\n  }\r\n\r\n  .header-top {\r\n    flex-wrap: nowrap;\r\n  }\r\n\r\n  .header-left {\r\n    flex: 1;\r\n    min-width: 0;\r\n    margin-right: 8px;\r\n  }\r\n\r\n  .header-right {\r\n    flex-wrap: nowrap;\r\n    gap: 8px;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .search-bar {\r\n    width: auto;\r\n    min-width: 36px;\r\n    padding: 8px 10px;\r\n  }\r\n\r\n  .search-bar input {\r\n    width: 120px;\r\n    font-size: 13px;\r\n  }\r\n\r\n  .user-profile {\r\n    gap: 6px;\r\n    padding: 6px 8px;\r\n  }\r\n\r\n  .user-profile span {\r\n    display: none;\r\n  }\r\n\r\n  .user-profile img {\r\n    width: 32px;\r\n    height: 32px;\r\n  }\r\n\r\n  /* Tags des salles : scroll horizontal */\r\n  .meetings-header {\r\n    flex-wrap: nowrap;\r\n    overflow-x: auto;\r\n    overflow-y: hidden;\r\n    -webkit-overflow-scrolling: touch;\r\n    scrollbar-width: none;\r\n    padding: 8px 0;\r\n    gap: 8px;\r\n    margin: 0 -8px;\r\n    padding-left: 16px;\r\n    padding-right: 16px;\r\n  }\r\n\r\n  .meetings-header::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n\r\n  .meeting-name-tag {\r\n    flex-shrink: 0;\r\n    padding: 6px 14px;\r\n    font-size: 13px;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  /* Créer salle */\r\n  .btn-create-room {\r\n    padding: 8px 18px;\r\n    font-size: 13px;\r\n  }\r\n\r\n  /* Tabs */\r\n  .tabs {\r\n    padding: 12px 16px 0;\r\n    gap: 4px;\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n    scrollbar-width: none;\r\n    margin: 0 -4px;\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n  }\r\n\r\n  .tabs::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n\r\n  .tab-item {\r\n    flex-shrink: 0;\r\n    padding: 10px 14px;\r\n    font-size: 13px;\r\n    line-height: 1.2;\r\n  }\r\n\r\n  /* Content */\r\n  .content {\r\n    padding: 12px 16px;\r\n    gap: 12px;\r\n  }\r\n\r\n  /* Cards */\r\n  .card {\r\n    padding: 16px;\r\n    border-radius: var(--radius-md);\r\n  }\r\n\r\n  .card h2 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .card h3 {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .card p {\r\n    font-size: 13px;\r\n    line-height: 1.6;\r\n  }\r\n\r\n  /* Recording items — stack image above text */\r\n  .recording-item {\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n\r\n  .recording-thumbnail img {\r\n    width: 100%;\r\n    height: auto;\r\n    aspect-ratio: 16 / 9;\r\n  }\r\n\r\n  .recording-info .button-group {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    gap: 8px;\r\n  }\r\n\r\n  .recording-info button {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n\r\n  /* File items — stack icon on top */\r\n  .file-item {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 10px;\r\n  }\r\n\r\n  .file-icon {\r\n    width: 40px;\r\n    height: 40px;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .file-item .btn-outline {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n\r\n  /* Settings items — stack toggle */\r\n  .setting-item {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 10px;\r\n  }\r\n\r\n  /* Members */\r\n  .member-item {\r\n    padding: 10px;\r\n    gap: 10px;\r\n  }\r\n\r\n  .member-avatar img {\r\n    width: 36px;\r\n    height: 36px;\r\n  }\r\n\r\n  /* Buttons full-width */\r\n  .button-group {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .btn-primary,\r\n  .btn-secondary,\r\n  .btn-outline {\r\n    width: 100%;\r\n    text-align: center;\r\n    padding: 12px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .btn-full-outline {\r\n    padding: 12px;\r\n    font-size: 13px;\r\n  }\r\n\r\n  /* Meeting list items */\r\n  .meeting-item {\r\n    padding: 12px;\r\n  }\r\n\r\n  /* Modal */\r\n  .modal-content {\r\n    width: 95%;\r\n    margin: 16px;\r\n    max-height: 90vh;\r\n    overflow-y: auto;\r\n    padding: 20px;\r\n  }\r\n\r\n  .modal-header h3 {\r\n    font-size: 17px;\r\n  }\r\n\r\n  /* Chat room (mode page) */\r\n  .left-panel > div,\r\n  .left-panel iframe {\r\n    max-height: 65vh;\r\n  }\r\n\r\n  /* Prevent horizontal scroll on entire page */\r\n  body {\r\n    overflow-x: hidden;\r\n  }\r\n}\r\n\r\n/* ══════════════════════════════════════════════════════\r\n   RESPONSIVE — 480px : très petit écran\r\n══════════════════════════════════════════════════════ */\r\n@media (max-width: 480px) {\r\n  .app-header {\r\n    padding: 10px 12px;\r\n  }\r\n\r\n  .header-left {\r\n    margin-right: 0;\r\n  }\r\n\r\n  .header-right {\r\n    gap: 4px;\r\n  }\r\n\r\n  .search-bar input {\r\n    width: 80px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .search-bar input::placeholder {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .meetings-header {\r\n    padding-left: 12px;\r\n    padding-right: 12px;\r\n  }\r\n\r\n  .meeting-name-tag {\r\n    padding: 5px 10px;\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n  }\r\n\r\n  .tabs {\r\n    padding-left: 12px;\r\n    padding-right: 4px;\r\n  }\r\n\r\n  .tab-item {\r\n    padding: 8px 10px;\r\n    font-size: 12px;\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n  }\r\n\r\n  .content {\r\n    padding: 10px 12px;\r\n    gap: 10px;\r\n  }\r\n\r\n  .card {\r\n    padding: 14px;\r\n  }\r\n\r\n  .card h2 {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .card p {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .btn-primary,\r\n  .btn-secondary {\r\n    padding: 11px 16px;\r\n    font-size: 13px;\r\n  }\r\n\r\n  .modal-content {\r\n    padding: 16px;\r\n    width: 92%;\r\n  }\r\n\r\n  .invite-modal-form .form-group input,\r\n  .create-room-form .form-group input,\r\n  .create-room-form .form-group textarea,\r\n  .create-room-form .form-group select {\r\n    padding: 10px 12px;\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n/* ══════════════════════════════════════════════════════\r\n   REDUCED MOTION\r\n══════════════════════════════════════════════════════ */\r\n@media (prefers-reduced-motion: reduce) {\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.01ms !important;\r\n  }\r\n}\r\n\r\n/* TOGGLE SWITCH */\n.toggle-switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 48px;\r\n  height: 24px;\r\n}\r\n\r\n.toggle-switch input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.toggle-slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: var(--border-color);\r\n  border-radius: 24px;\r\n  transition: 0.3s;\r\n}\r\n\r\n.toggle-slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 18px;\r\n  width: 18px;\r\n  left: 3px;\r\n  bottom: 3px;\r\n  background: white;\r\n  border-radius: 50%;\r\n  transition: 0.3s;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.toggle-switch input:checked + .toggle-slider {\r\n  background: var(--accent-primary);\r\n}\r\n\r\n.toggle-switch input:checked + .toggle-slider:before {\r\n  transform: translateX(24px);\r\n}\r\n\r\n/* ROOM ACTIONS BUTTONS */\r\n.card-header-with-actions {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.room-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.btn-icon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  background: transparent;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: var(--radius-sm);\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.btn-icon:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.btn-edit:hover {\r\n  border-color: var(--accent-primary);\r\n  color: var(--accent-primary);\r\n  background: var(--accent-light);\r\n}\r\n\r\n.btn-delete:hover {\r\n  border-color: var(--danger);\r\n  color: var(--danger);\r\n  background: rgba(220, 38, 38, 0.08);\r\n}\r\n\r\n.btn-icon:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n  transform: none;\r\n}\r\n\r\n/* Video Player Styles for Recordings */\r\n.video-player-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.video-player-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.recording-video-player {\r\n  width: 100%;\r\n  max-height: 400px;\r\n  border-radius: var(--radius-md);\r\n  background: var(--bg-elevated);\r\n}\r\n\r\n.recording-info-full {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding: 16px;\r\n  background: var(--bg-elevated);\r\n  border-radius: var(--radius-md);\r\n}\r\n\r\n.recording-info-full p {\r\n  margin: 4px 0;\r\n  font-size: 14px;\r\n  color: var(--text-secondary);\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.recording-info-full p span {\r\n  font-size: 16px;\r\n}\r\n\r\n.recording-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.btn-delete-recording {\r\n  background: var(--danger) !important;\r\n  color: white !important;\r\n  border-color: var(--danger) !important;\r\n}\r\n\r\n.btn-delete-recording:hover {\r\n   background: #b91c1c !important;\r\n   border-color: #b91c1c !important;\r\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
